import React, { useMemo, useRef, useState } from 'react'
import './index.scss'
import { debounce } from 'lodash'
import clsx from 'clsx'
import { ICONS } from '@Const/common'

interface InputSearchProps {
    mainColor: boolean
    id: string
    onChange: (value: string, id: string) => void
    value?: string
}

const InputSearch = ({ mainColor, id, onChange, value }: InputSearchProps) => {
    const [inputValue, setInputValue] = useState(value || '')
    const [activeInputState, setActiveInputState] = useState(false)
    const inputValueRef = useRef(inputValue)
    inputValueRef.current = inputValue

    const onFocusInput = () => setActiveInputState(true)

    const onBlurInput = () => setActiveInputState(false)

    const onSave = useMemo(
        () =>
            debounce(() => {
                onChange(inputValueRef.current, id)
            }, 200),
        [onChange, id]
    )

    const handleChange = (event: any) => {
        setInputValue(event.target.value)
        onSave()
    }

    const classNames = clsx(
        'input-search-component',
        mainColor ? 'main-color-set' : 'second-color-set',
        activeInputState && 'focused',
        inputValue && 'filled'
    )

    return (
        <div className={classNames} data-testid={'input-search-component-' + id}>
            <input
                type="text"
                id={id}
                onBlur={onBlurInput}
                onFocus={onFocusInput}
                onChange={handleChange}
                placeholder={!activeInputState ? 'Search' : ''}
            />
            <img src={ICONS.search_alt} alt="search" />
        </div>
    )
}

export default InputSearch
